import React from 'react'
import { propOr } from 'ramda'

import { useSegmentation } from '../_load/SegmentationLoader'

export const useSegmentationFormattedFormData = () => {
  const segmentation = useSegmentation()

  const placeLevels = propOr([], 'placeLevels', segmentation)
  const userGroups = propOr([], 'userGroups', segmentation)
  const checklistTypes = propOr([], 'checklistTypes', segmentation)
  const assets = propOr([], 'assets', segmentation)

  return React.useMemo(() => {
    if (!segmentation || !segmentation.id) return {}

    return {
      ...segmentation,
      placeLevels: placeLevels.length ? placeLevels : ['all'],
      userGroups: userGroups.length ? userGroups : ['all'],
      checklistTypes: checklistTypes.length ? checklistTypes : ['all'],
      assets: assets.length ? assets : ['all']
    }
  }, [])
}
